/**
 * 本地存储键名：最近浏览商品
 * @type {string}
 */
export const RECENTLY_VIEWED_KEY = "jky-recently-viewed";

/**
 * @namespace ThemeEvents
 * @description 主题事件集合，用于触发和监听主题中的变化。
 * @example
 * document.dispatchEvent(new QuantitySelectorUpdateEvent(quantity, cartLine));
 * document.addEventListener(ThemeEvents.quantitySelectorUpdate, (e) => { console.log(e.detail.quantity) });
 */
export class ThemeEvents {
  // 数量选择器值变更事件
  static quantitySelectorUpdate = 'quantity-selector:update';
}

/**
 * 数量选择器值变更事件类
 * @extends {Event}
 */
export class QuantitySelectorUpdateEvent extends Event {
  /**
   * Creates a new QuantitySelectorUpdateEvent
   * @param {number} quantity - 数量选择器的新值
   * @param {number} [cartLine] - 购物车行ID，用于标识更新的购物车行
   */
  constructor(quantity, cartLine) {
    super(ThemeEvents.quantitySelectorUpdate, { bubbles: true });
    this.detail = {
      quantity,
      cartLine
    };
  }
}